export default __webpack_public_path__ + "static/media/scdream3.8c552960.woff";